import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=1c647d34"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
import style0 from "./Menu.vue?vue&type=style&index=0&id=1c647d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports